<script setup>

</script>

<template>
  <h1>Deals</h1>
</template>

<style scoped>

</style>
